import React, { Component } from "react";
import "scss/backup.scss";
import { connect } from "react-redux";
import { AssinaturaDetalhes2 } from "components/assinatura/AssinaturaDetalhes2";
import { Helmet } from "react-helmet";
import { PersonActions } from "state/actions/user/PersonActions";
import { Tabs } from "components/general/Tabs";
import { Tab } from "components/general/Tab";
import { PossibleSubscriberIds } from "core/utils/SubscriberUtils";

export class Assinatura extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      subscriptionInfo: null,
      subscriptions: this.props.person.subs,
      subscriberId: null,
      
      subscriberStatusToFilter: 0,
      subscriptionIdToFilter: 1
    };

    this.renderSubscriptionsTabs = this.renderSubscriptionsTabs.bind(this);
    this.updateSubscriptionRoot = this.updateSubscriptionRoot.bind(this);

  }

  componentDidMount() {
    const filteredSubs = this.filterValidSubs();

    let orderedSubs = this.orderSubsByDesc(filteredSubs);
    
    orderedSubs = orderedSubs.filter(
      (item) => {
        return (
          item.subscriptionId === 1 
        );
      }
    );

    if (orderedSubs.length === 0) return null;
  
    this.setState({ subscriptions: orderedSubs });
  }

  filterValidSubs = () =>{
    let isGlampartner = 
      this.props.person.person.personStatus === 14 ? true : false;
    return PossibleSubscriberIds(this.state.subscriptions, false, isGlampartner);
  };

  orderSubsByDesc = (subs) => {
    return subs.sort((a, b) => {
      return b.id - a.id
    });
  };

  updateSubscriptionRoot(rootData){
    let { subscriptions } = this.state;
    subscriptions.forEach((item, key) => {
      if (item.id === rootData.id) {
        subscriptions[key] = Object.assign({}, item, rootData);
      }
    });

    let { person } = this.props;
    person.subs = subscriptions;
    this.props.updatePersonInfo(person);

    this.setState({
      subscriptionInfo: rootData,
      subscriptions
    }, ()=> {
    });
  }

  renderSubscriptionDetails(subscriberId) {
    let subs = this.state.subscriptions;
    const subscriptionInfo = subs.filter(
      (item) => {
        return item.id === subscriberId;
      }
    );

    let current = subscriptionInfo.shift();

    return (
      <AssinaturaDetalhes2 subscriberId={subscriberId}
                           callback={this.updateSubscriptionRoot} 
                           subscriptionInfo={current}/>
    );
  }

  renderSubscriptionsTabs() {
    const { subscriptions } = this.state;
    
    return subscriptions.map((item, key) => {
      return (
        <Tab key={key} label={item.boxId} className={""}>
          <div>
            {this.renderSubscriptionDetails(item.id)}
          </div>
        </Tab>
      );
    })
  }
  
  render() {
    const { props, state } = this;
    //TODO colocar a página correta
    if (state.subscriptions.length === 0) {
      return (
        <div className={"p-2 p-lg-5"}>  
          <Helmet>
          <title>Minha Glambox : Assinaturas</title>
          </Helmet>
      
          <h1>Assinaturas</h1>
  
          <div className={"p-2 p-lg-5 text-center"}>
            <p className={"lead text-muted"}>Ops! Você ainda não tem nenhuma assinatura ativa!</p>
          </div>
        </div>
      );
    }

    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : Assinatura</title>
        </Helmet>
        
        <h1>Assinatura</h1>
        <Tabs>
          {this.renderSubscriptionsTabs()}
        </Tabs>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    person: state.person.data
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updatePersonInfo: (personInfo) => {
      dispatch(PersonActions.updatePersonInfo(personInfo));
    }
  };
};

Assinatura = connect(mapStateToProps, mapDispatchToProps)(Assinatura);